module.exports = __webpack_public_path__ + "static/zbrush-logo-085b0da2b61f0ca028be5c570ccb04d8.png";